import { Component, inject, input, viewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../../shared/services/dialog.service';

import { StateService } from '../../services/state.service';
import { InformationChartDialogComponent } from '../../../shared/information-chart-dialog/information-chart-dialog.component';


@Component({
  selector: 'app-chart-info-box',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chart-info-box.component.html',
  styleUrl: './chart-info-box.component.scss'
})
export class ChartInfoBoxComponent {
  readonly information = input<string | null>();
  dialog = viewChild.required('dialog', { read: ViewContainerRef });
  readonly isPrinting = inject(StateService).isPrinting;
  readonly printInfo = inject(StateService).printInfo;
  private dialogService = inject(DialogService);
  public dialogInformationId = input<string>('');

  openInformation() {
    this.dialogService.show(this.dialog(), InformationChartDialogComponent, null, this.dialogInformationId()).subscribe();
    return false;
  }
}
